import React, { useEffect } from "react";
import Navbar from "../../Components/Navbar";
import Maitre from "../../Components/Projects/Maitre";
import Overview from "../../Components/Projects/Overview";
import ScrollMagic from "scrollmagic";
import Solution from "../../Components/Solution/Solution";
import Contactbanner from "../../Components/Contactbanner/Contactbanner";
import imageData from "../../Images/skill.svg";
import FoodrnaContactUs from "../Foodarna/FoodrnaContactUs/FoodrnaContactUs";
import { Helmet } from "react-helmet-async";

const ProjectDetail = () => {
  useEffect(() => {
    const controller = new ScrollMagic.Controller();

    setTimeout(() => {
      window.scrollTo(0, 0);
      const triggerElement = document.getElementById("triggerPinned");

      if (window.innerWidth > 768 && triggerElement) {
        new ScrollMagic.Scene({
          triggerElement: triggerElement,
          triggerHook: 0,
        })
          .setPin(triggerElement)
          .addTo(controller);
      }
    }, 0);

    return () => controller.destroy();
  }, []);

  return (
    <>
      <Helmet>
        <title>Skillioz ProDetail |Advanced Product Insights and Analysis</title>
        <meta
          name="description"
          content="Dive into Skillioz Product Detail — offering detailed product analytics, insights & expert evaluations to help you make smarter decisions & understand performance deeper."
        />
      </Helmet>
      <div style={{ overflowX: "hidden", color: "#313F78" }}>
        <Navbar />
        <div>
          <section id="triggerPinned" className="!mt-20 md:!mt-0 !min-h-[60vh] md:min-h-[100vh]">
            <Maitre
              text="Skillioz"
              imgdata={imageData}
              desc="Your Smarter ATS, Powered by AI Track. Evaluate. Hire. Smarter."
            />
          </section>
          <section
            className="project-detail"
            style={{
              zIndex: "1",
              color: "black",
              padding: "0px",
            }}
          >
            <Overview />
            <Solution />
          </section>
        </div>
      </div>
    </>
  );
};

export default ProjectDetail;
